import * as React from 'react';

type ListItemType = {
  title: string;
  src: string;
  alt: string;
};
export const ListItem = ({ title, src, alt }: ListItemType): React.ReactElement => (
  <li className="list-group-item d-flex flex-column align-items-center mt-4">
    <span className="italic fw-semibold my-2">{title}</span>
    <img className="img-fluid" src={src} alt={alt} />
  </li>
);
